// import React, { useEffect, useState } from 'react';
// import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
// import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
// import BookmarkIcon from '@mui/icons-material/Bookmark';
// import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
// import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
// import TaskAltIcon from '@mui/icons-material/TaskAlt';
// import PhonelinkEraseIcon from '@mui/icons-material/PhonelinkErase';
// import ThumbUpIcon from '@mui/icons-material/ThumbUp';
// import CancelIcon from '@mui/icons-material/Cancel';
// import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
// import BackspaceIcon from '@mui/icons-material/Backspace';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useTheme, CircularProgress, Box } from '@mui/material';
// import { GetallStagesWithLeadsCount_For_Admin_Dashboard_Action } from '../../Redux/Actions/UsersAction';
// import NewReleasesOutlinedIcon from '@mui/icons-material/NewReleasesOutlined';
// import ControlPointDuplicateOutlinedIcon from '@mui/icons-material/ControlPointDuplicateOutlined';
// import HourglassEmptyOutlinedIcon from '@mui/icons-material/HourglassEmptyOutlined';
// import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';
// import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
// import AccessAlarmOutlinedIcon from '@mui/icons-material/AccessAlarmOutlined';
// import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';
// import Person3OutlinedIcon from '@mui/icons-material/Person3Outlined';
// import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
// import DoDisturbOutlinedIcon from '@mui/icons-material/DoDisturbOutlined';
// import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
// import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
// import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
// import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
// export const QuickNumbers = ({ darkMode = false }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [userlogin, setUserLogin] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
//   const [totalCustomers, setTotalCustomers] = useState(0);

//   const stagesIcons = {
//     Fresh: <NewReleasesOutlinedIcon />,
//     Follow: <PersonAddAltOutlinedIcon />,
//     'Follow Up': <HourglassEmptyOutlinedIcon />,
//     'Long Follow': <EventRepeatOutlinedIcon />,
//     Interested: <StarOutlineOutlinedIcon />,
//     'Not Interested': <DoNotDisturbOnOutlinedIcon />,
//     'No Answer': <PhonelinkEraseIcon />,
//     'No Answer 1st Call': <AccessAlarmIcon />,
//     Meeting: <AccessAlarmOutlinedIcon />,
//     'Follow After Meeting': <HistoryOutlinedIcon />,
//     'Cancel Meeting': <DoDisturbOutlinedIcon />,

//     'Done Deal': <TaskAltIcon />,
//     Reservation: <EventAvailableOutlinedIcon />,
//     EOI: (
//       <svg
//         width="30"
//         height="36"
//         viewBox="0 0 24 24"
//         fill="none"
//         stroke="#000"
//         stroke-width="1.5"
//         stroke-linecap="round"
//         stroke-linejoin="round"
//         xmlns="http://www.w3.org/2000/svg"
//       >
//         <path d="M6 2H14L20 8V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z" />
//         <path d="M9 13L11 15L16 10" stroke="#000" stroke-width="1" fill="none" />
//       </svg>
//     ),
//     Transfer: <ArrowCircleLeftOutlinedIcon />,
//   };

//   useEffect(() => {
//     const user = localStorage.getItem('user');
//     if (user) {
//       setUserLogin(JSON.parse(user));
//     }
//   }, []);

//   const resAllStagesWithleadscount = useSelector((state) => state.Allusers.Stages_With_LeadsCount);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       await dispatch(GetallStagesWithLeadsCount_For_Admin_Dashboard_Action());
//     };
//     fetchData();
//   }, [dispatch]);

//   useEffect(() => {
//     if (resAllStagesWithleadscount?.data) {
//       setStageLeadscountarray(resAllStagesWithleadscount.data);
//       setTotalCustomers(resAllStagesWithleadscount.totalLeads || 0);
//       setLoading(false);
//     }
//   }, [resAllStagesWithleadscount]);

//   const refreshLeads = () => {
//     localStorage.removeItem('stagestorage');
//     if (userlogin?.data?.role === 'Admin') navigate('/AllLeadsForAdmin');
//     else navigate('/ALLLeadsForMarketer');
//   };

//   const handleStageClick = (stage) => {
//     localStorage.setItem('stagestorage', stage);
//     navigate(`/AllLeadsForAdmin?stage=${encodeURIComponent(stage)}`);
//   };

//   const handleGoToDuplicates = () => {
//     navigate('/AllLeadsForAdmin?duplicates=true&ignoreduplicate=true');
//   };

//   if (loading && stageLeadscountarray.length === 0) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="300px">
//         <CircularProgress style={{ color: '#102dff' }} />
//       </Box>
//     );
//   }

//   console.log('stageLeadscountarray', stageLeadscountarray);
//   return (
//     <div style={{ width: '100%' }} className="fade-in">
//       <div
//         className={`section-title ${darkMode ? 'dark' : ''}`}
//         style={{
//           color: mode === 'dark' ? '#90caf9' : '#102dff',
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//         }}
//       >
//         {/* العنوان على اليسار */}
//         <span>Quick Numbers</span>

//         {/* الزر على اليمين */}
//         <button
//           style={{
//             padding: '6px 15px',
//             backgroundColor: mode === 'dark' ? '#2196f3' : '#1976d2',
//             color: 'white',
//             border: 'none',
//             borderRadius: '4px',
//             cursor: 'pointer',
//             fontSize: '14px',
//             fontWeight: 'bold',
//             transition: 'background-color 0.3s',
//           }}
//           onMouseEnter={(e) => {
//             e.target.style.backgroundColor = mode === 'dark' ? '#42a5f5' : '#1565c0';
//           }}
//           onMouseLeave={(e) => {
//             e.target.style.backgroundColor = mode === 'dark' ? '#2196f3' : '#1976d2';
//           }}
//           onClick={() => {
//             navigate('/AllLeadsForAdminCRMDataQuickNumbers');
//           }}
//         >
//           CRM DATA
//         </button>
//       </div>

//       <div className="simple-cards-container">
//         {/* All Leads */}
//         <div
//           style={{
//             background: mode === 'dark' ? '#0F7687' : '#fff',
//             color: mode === 'dark' ? '#fff' : '#333',
//           }}
//           className={`simple-card ${darkMode ? 'dark' : ''}`}
//           onClick={refreshLeads}
//         >
//           {/* <div className={`card-icon ${darkMode ? 'dark' : ''}`}>
//         <AccessibilityNewIcon style={{color:mode==="dark"?"#fff":"#333"}} />
//       </div> */}
//           <div className="card-content">
//             <h3
//               className={darkMode ? 'dark' : ''}
//               style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
//             >
//               <Person3OutlinedIcon style={{ color: mode === 'dark' ? '#fff' : '#333' }} />
//               <h3
//                 style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                 className={darkMode ? 'dark' : ''}
//               >
//                 All Leads
//               </h3>
//             </h3>
//             <p
//               style={{ color: mode === 'dark' ? '#fff' : '#666' }}
//               className={darkMode ? 'dark' : ''}
//             >
//               Total system leads
//             </p>
//             <div
//               className="card-stats"
//               style={{ display: 'flex', justifyContent: 'space-between' }}
//             >
//               <span
//                 style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                 className={`count ${darkMode ? 'dark' : ''} `}
//               >
//                 {totalCustomers}
//               </span>
//               <span className={`percentage ${darkMode ? 'dark' : ''} mx-2`}>100%</span>
//             </div>
//           </div>
//         </div>

//         {/* Duplicate Card (second position) */}
//         {stageLeadscountarray
//           .filter((stage) => stage.stageName === 'Duplicate')
//           .map(({ stageName, leadCount, percentage }) => {
//             const icon = stagesIcons[stageName] || <ControlPointDuplicateOutlinedIcon />;
//             return (
//               <div
//                 key={stageName}
//                 className={`simple-card ${darkMode ? 'dark' : ''}`}
//                 onClick={handleGoToDuplicates}
//                 style={{
//                   background: mode === 'dark' ? '#0F7687' : '#fff',
//                   color: mode === 'dark' ? '#fff' : '#333',
//                 }}
//               >
//                 <div className="card-content">
//                   <h3
//                     className={darkMode ? 'dark' : ''}
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '8px',
//                     }}
//                   >
//                     {icon}
//                     {stageName}
//                   </h3>
//                   <p
//                     style={{ color: mode === 'dark' ? '#fff' : '#666' }}
//                     className={darkMode ? 'dark' : ''}
//                   >
//                     Leads with multiple versions
//                   </p>
//                   <div
//                     className="card-stats"
//                     style={{ display: 'flex', justifyContent: 'space-between' }}
//                   >
//                     <span
//                       style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                       className={`count ${darkMode ? 'dark' : ''}`}
//                     >
//                       {leadCount}
//                     </span>
//                     <span className={`percentage ${darkMode ? 'dark' : ''} mx-2`}>
//                       {percentage}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}

//         {/* Other Stages */}
//         {stageLeadscountarray
//           .filter((stage) => stage.stageName !== 'Duplicate')
//           .map(({ stageId, stageName, leadCount, percentage }) => {
//             const icon = stagesIcons[stageName] || <AutorenewOutlinedIcon />;
//             return (
//               <div
//                 key={stageId}
//                 className={`simple-card ${darkMode ? 'dark' : ''}`}
//                 onClick={() => handleStageClick(stageId)}
//                 style={{
//                   background: mode === 'dark' ? '#0F7687' : '#fff',
//                   color: mode === 'dark' ? '#fff' : '#333',
//                 }}
//               >
//                 <div className="card-content">
//                   <h3
//                     className={darkMode ? 'dark' : ''}
//                     style={{
//                       color: mode === 'dark' ? '#fff' : '#333',
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '8px',
//                     }}
//                   >
//                     {icon}
//                     {stageName}
//                   </h3>
//                   <p
//                     style={{ color: mode === 'dark' ? '#fff' : '#666' }}
//                     className={darkMode ? 'dark' : ''}
//                   >
//                     Leads Of All System
//                   </p>
//                   <div
//                     className="card-stats"
//                     style={{ display: 'flex', justifyContent: 'space-between' }}
//                   >
//                     <span
//                       style={{ color: mode === 'dark' ? '#fff' : '#333' }}
//                       className={`count ${darkMode ? 'dark' : ''}`}
//                     >
//                       {leadCount}
//                     </span>
//                     <span className={`percentage ${darkMode ? 'dark' : ''} mx-2`}>
//                       {percentage}
//                     </span>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//       </div>
//     </div>
//   );
// };





















// // 20-5-2026
// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { useTheme, CircularProgress, Box } from '@mui/material';
// import { GetallStagesWithLeadsCount_For_Admin_Dashboard_Action } from '../../Redux/Actions/UsersAction';
// import TrendingUpIcon   from '@mui/icons-material/TrendingUp';
// import TrendingDownIcon from '@mui/icons-material/TrendingDown';

// /* ── number colour per stage ───────────────────────────────────────── */
// const numberColor = (stageName) => {
//   if (!stageName) return null;
//   const n = stageName.toLowerCase();
//   if (n.includes('cancel'))         return '#C62828';
//   if (n.includes('not interested')) return '#C62828';
//   if (n.includes('pending'))        return '#B8860B';
//   if (n.includes('done deal'))      return '#1B5E20';
//   if (n.includes('reservation'))    return '#1B5E20';
//   if (n.includes('eoi'))            return '#0D47A1';
//   return null;
// };

// /* ── badge style based on percentage value ──────────────────────────── */
// const trendStyle = (pct) => {
//   if (pct > 0)  return { bg: '#EBF2FF', color: '#1A3ECF' };
//   if (pct === 0) return { bg: '#F3F4F6', color: '#6B7280' };
//   return { bg: '#F3F4F6', color: '#6B7280' };
// };

// /* ══════════════════════════════════════════════════════════════════ */
// export const QuickNumbers = () => {
//   const theme    = useTheme();
//   const dark     = theme.palette.mode === 'dark';
//   const dispatch = useDispatch();
//   const navigate = useNavigate();

//   const [userlogin,            setUserLogin]            = useState(null);
//   const [loading,              setLoading]              = useState(true);
//   const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
//   const [totalCustomers,       setTotalCustomers]       = useState(0);

//   useEffect(() => {
//     const u = localStorage.getItem('user');
//     if (u) setUserLogin(JSON.parse(u));
//   }, []);

//   const res = useSelector((s) => s.Allusers.Stages_With_LeadsCount);

//   useEffect(() => {
//     const fetchData = async () => {
//       setLoading(true);
//       await dispatch(GetallStagesWithLeadsCount_For_Admin_Dashboard_Action());
//     };
//     fetchData();
//   }, [dispatch]);

//   useEffect(() => {
//     if (res?.data) {
//       setStageLeadscountarray(res.data);
//       setTotalCustomers(res.totalLeads || 0);
//       setLoading(false);
//     }
//   }, [res]);

//   const refreshLeads     = () => {
//     localStorage.removeItem('stagestorage');
//     userlogin?.data?.role === 'Admin'
//       ? navigate('/AllLeadsForAdmin')
//       : navigate('/ALLLeadsForMarketer');
//   };
//   const handleStageClick = (id) => {
//     localStorage.setItem('stagestorage', id);
//     navigate(`/AllLeadsForAdmin?stage=${encodeURIComponent(id)}`);
//   };
//   const handleDuplicates = () =>
//     navigate('/AllLeadsForAdmin?duplicates=true&ignoreduplicate=true');

//   /* ── tokens ── */
//   const cardBg  = dark ? '#1E1E2E' : '#FFFFFF';
//   const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';
//   const textPri = dark ? '#E2E8F0' : '#111827';
//   const textSec = dark ? '#94A3B8' : '#9CA3AF';
//   const accent  = '#1A3ECF';

//   if (loading && stageLeadscountarray.length === 0) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height={300}>
//         <CircularProgress style={{ color: accent }} />
//       </Box>
//     );
//   }

//   /* ── حساب النسبة الحقيقية من total ── */
//   const calcPct = (count) => {
//     if (!totalCustomers || totalCustomers === 0) return 0;
//     return Math.round((count / totalCustomers) * 100);
//   };

//   /* ── single card ── */
//   const Card = ({ stageName, leadCount, onClick, pct }) => {
//     const ts     = trendStyle(pct);
//     const numCol = numberColor(stageName) || (dark ? '#E2E8F0' : '#111827');

//     return (
//       <div
//         onClick={onClick}
//         style={{
//           background    : cardBg,
//           border        : `1px solid ${border}`,
//           borderRadius  : 16,
//           padding       : '24px 22px 20px',
//           cursor        : 'pointer',
//           position      : 'relative',
//           transition    : 'box-shadow 0.18s, transform 0.18s',
//           display       : 'flex',
//           flexDirection : 'column',
//           justifyContent: 'space-between',
//           minHeight     : 115,
//         }}
//         onMouseEnter={(e) => {
//           e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)';
//           e.currentTarget.style.transform = 'translateY(-2px)';
//         }}
//         onMouseLeave={(e) => {
//           e.currentTarget.style.boxShadow = 'none';
//           e.currentTarget.style.transform = 'translateY(0)';
//         }}
//       >
//         {/* ✅ badge بالنسبة الحقيقية من total leads */}
//         <div style={{
//           position    : 'absolute',
//           top         : 16,
//           right       : 16,
//           display     : 'flex',
//           alignItems  : 'center',
//           gap         : 2,
//           fontSize    : 11,
//           fontWeight  : 600,
//           color       : ts.color,
//           background  : ts.bg,
//           borderRadius: 20,
//           padding     : '3px 8px',
//           lineHeight  : 1,
//         }}>
//           {pct > 0 && <TrendingUpIcon style={{ fontSize: 12 }} />}
//           {pct}%
//         </div>

//         {/* big number */}
//         <div style={{
//           fontSize     : 42,
//           fontWeight   : 800,
//           color        : numCol,
//           lineHeight   : 1,
//           fontFamily   : "'DM Sans', sans-serif",
//           letterSpacing: '-1.5px',
//         }}>
//           {typeof leadCount === 'number' ? leadCount.toLocaleString() : leadCount}
//         </div>

//         {/* stage label */}
//         <div style={{
//           fontSize     : 11,
//           fontWeight   : 600,
//           letterSpacing: '0.09em',
//           color        : textSec,
//           marginTop    : 16,
//           textTransform: 'uppercase',
//         }}>
//           {stageName}
//         </div>
//       </div>
//     );
//   };

//   /* ── render ── */
//   return (
//     <div style={{ width: '100%' }}>

//       {/* section header */}
//       <div style={{
//         display       : 'flex',
//         justifyContent: 'space-between',
//         alignItems    : 'flex-start',
//         marginBottom  : 22,
//       }}>
//         <div>
//           <h2 style={{
//             margin    : 0,
//             fontSize  : 20,
//             fontWeight: 700,
//             color     : textPri,
//             fontFamily: "'DM Sans', sans-serif",
//           }}>
//             Quick Numbers
//           </h2>
//           <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
//             Real-time engagement metrics for your portfolio
//           </p>
//         </div>

//         <button
//           onClick={() => navigate('/AllLeadsForAdminCRMDataQuickNumbers')}
//           style={{
//             background    : 'none',
//             border        : 'none',
//             cursor        : 'pointer',
//             color         : accent,
//             fontSize      : 13,
//             fontWeight    : 700,
//             fontFamily    : "'DM Sans', sans-serif",
//             textDecoration: 'none',
//             padding       : 0,
//           }}
//           onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
//           onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
//         >
//           View Data Center
//         </button>
//       </div>

//       {/* card grid */}
//       <div style={{
//         display            : 'grid',
//         gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//         gap                : 16,
//       }}>
//         {/* All Leads — 100% دايماً */}
//         <Card
//           stageName ="All Leads"
//           leadCount ={totalCustomers}
//           onClick   ={refreshLeads}
//           pct       ={100}
//         />

//         {/* Duplicate */}
//         {stageLeadscountarray
//           .filter((s) => s.stageName === 'Duplicate')
//           .map(({ stageName, leadCount }) => (
//             <Card
//               key      ="dup"
//               stageName={stageName}
//               leadCount={leadCount}
//               onClick  ={handleDuplicates}
//               pct      ={calcPct(leadCount)}
//             />
//           ))}

//         {/* All other stages */}
//         {stageLeadscountarray
//           .filter((s) => s.stageName !== 'Duplicate')
//           .map(({ stageId, stageName, leadCount }) => (
//             <Card
//               key      ={stageId}
//               stageName={stageName}
//               leadCount={leadCount}
//               onClick  ={() => handleStageClick(stageId)}
//               pct      ={calcPct(leadCount)}
//             />
//           ))}
//       </div>
//     </div>
//   );
// };











// After 20-5-2026
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme, CircularProgress, Box } from '@mui/material';
import { GetallStagesWithLeadsCount_For_Admin_Dashboard_Action } from '../../Redux/Actions/UsersAction';
import TrendingUpIcon   from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';

/* ── الترتيب المطلوب ── */
const STAGE_ORDER = [
  'All Leads',
  'Duplicate',
  'Pool',
  'Fresh',
  'No Answer',
  'Follow Up',
  'Interested',
  'Meeting',
  'Follow After Meeting',
  'EOI',
  'Done Deal',
  'Cancel Meeting',
  'Transfer',
  'Not Interested',
  'No Stage',
  'Pending',
];

/* ── number colour per stage ───────────────────────────────────────── */
const numberColor = (stageName) => {
  if (!stageName) return null;
  const n = stageName.toLowerCase();
  if (n.includes('cancel'))         return '#C62828';
  if (n.includes('not interested')) return '#C62828';
  if (n.includes('pending'))        return '#B8860B';
  if (n.includes('done deal'))      return '#1B5E20';
  if (n.includes('reservation'))    return '#1B5E20';
  if (n.includes('eoi'))            return '#0D47A1';
  return null;
};

/* ── badge style based on percentage value ──────────────────────────── */
const trendStyle = (pct) => {
  if (pct > 0)   return { bg: '#EBF2FF', color: '#1A3ECF' };
  if (pct === 0) return { bg: '#F3F4F6', color: '#6B7280' };
  return { bg: '#F3F4F6', color: '#6B7280' };
};

/* ══════════════════════════════════════════════════════════════════ */
export const QuickNumbers = () => {
  const theme    = useTheme();
  const dark     = theme.palette.mode === 'dark';
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [userlogin,            setUserLogin]            = useState(null);
  const [loading,              setLoading]              = useState(true);
  const [stageLeadscountarray, setStageLeadscountarray] = useState([]);
  const [totalCustomers,       setTotalCustomers]       = useState(0);

  useEffect(() => {
    const u = localStorage.getItem('user');
    if (u) setUserLogin(JSON.parse(u));
  }, []);

  const res = useSelector((s) => s.Allusers.Stages_With_LeadsCount);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await dispatch(GetallStagesWithLeadsCount_For_Admin_Dashboard_Action());
    };
    fetchData();
  }, [dispatch]);

  useEffect(() => {
    if (res?.data) {
      setStageLeadscountarray(res.data);
      setTotalCustomers(res.totalLeads || 0);
      setLoading(false);
    }
  }, [res]);

  const refreshLeads     = () => {
    localStorage.removeItem('stagestorage');
    userlogin?.data?.role === 'Admin'
      ? navigate('/AllLeadsForAdmin')
      : navigate('/ALLLeadsForMarketer');
  };
  const handleStageClick = (id) => {
    localStorage.setItem('stagestorage', id);
    navigate(`/AllLeadsForAdmin?stage=${encodeURIComponent(id)}`);
  };
  const handleDuplicates = () =>
    navigate('/AllLeadsForAdmin?duplicates=true&ignoreduplicate=true');

  /* ✅ Pool card handler — بس الليدز اللي (No Stage) + (No Sales) مع بعض.
     ده مش Stage حقيقي فمينفعش نستخدم handleStageClick (اللي بيبني ?stage=<id>). */
  const handlePoolOnly = () =>
    navigate('/AllLeadsForAdmin?poolonly=true');

  /* ── tokens ── */
  const cardBg  = dark ? '#1E1E2E' : '#FFFFFF';
  const border  = dark ? 'rgba(255,255,255,0.07)' : '#E8EAF0';
  const textPri = dark ? '#E2E8F0' : '#111827';
  const textSec = dark ? '#94A3B8' : '#9CA3AF';
  const accent  = '#1A3ECF';

  if (loading && stageLeadscountarray.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={300}>
        <CircularProgress style={{ color: accent }} />
      </Box>
    );
  }

  /* ── حساب النسبة الحقيقية من total ── */
  const calcPct = (count) => {
    if (!totalCustomers || totalCustomers === 0) return 0;
    return Math.round((count / totalCustomers) * 100);
  };

  /* ── ترتيب الكروت حسب STAGE_ORDER ── */
  const allCardsRaw = [
    /* All Leads ثابت أول */
    {
      key      : 'all-leads',
      stageName: 'All Leads',
      leadCount: totalCustomers,
      onClick  : refreshLeads,
      pct      : 100,
    },
    /* Duplicate */
    ...stageLeadscountarray
      .filter((s) => s.stageName === 'Duplicate')
      .map(({ stageName, leadCount }) => ({
        key      : 'dup',
        stageName,
        leadCount,
        onClick  : handleDuplicates,
        pct      : calcPct(leadCount),
      })),
    /* ✅ Pool — كارت مستقل، مش جزء من الـ stages العادية، بيودّي على poolonly=true */
    ...stageLeadscountarray
      .filter((s) => s.stageName === 'Pool')
      .map(({ stageName, leadCount }) => ({
        key      : 'pool',
        stageName,
        leadCount,
        onClick  : handlePoolOnly,
        pct      : calcPct(leadCount),
      })),
    /* باقي الـ stages (مستبعد منها Duplicate و Pool) */
    ...stageLeadscountarray
      .filter((s) => s.stageName !== 'Duplicate' && s.stageName !== 'Pool')
      .map(({ stageId, stageName, leadCount }) => ({
        key      : stageId,
        stageName,
        leadCount,
        onClick  : () => handleStageClick(stageId),
        pct      : calcPct(leadCount),
      })),
  ];

  /* رتّب حسب STAGE_ORDER، اللي مش موجود في القايمة يتحط في الآخر */
  const sortedCards = [...allCardsRaw].sort((a, b) => {
    const ai = STAGE_ORDER.findIndex(
      (name) => name.toLowerCase() === a.stageName.toLowerCase()
    );
    const bi = STAGE_ORDER.findIndex(
      (name) => name.toLowerCase() === b.stageName.toLowerCase()
    );
    const aIdx = ai === -1 ? 999 : ai;
    const bIdx = bi === -1 ? 999 : bi;
    return aIdx - bIdx;
  });

  /* ── single card ── */
  const Card = ({ stageName, leadCount, onClick, pct }) => {
    const ts     = trendStyle(pct);
    const numCol = numberColor(stageName) || (dark ? '#E2E8F0' : '#111827');

    return (
      <div
        onClick={onClick}
        style={{
          background    : cardBg,
          border        : `1px solid ${border}`,
          borderRadius  : 16,
          padding       : '24px 22px 20px',
          cursor        : 'pointer',
          position      : 'relative',
          transition    : 'box-shadow 0.18s, transform 0.18s',
          display       : 'flex',
          flexDirection : 'column',
          justifyContent: 'space-between',
          minHeight     : 115,
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.boxShadow = '0 6px 24px rgba(0,0,0,0.08)';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.boxShadow = 'none';
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        {/* badge بالنسبة من total leads */}
        <div style={{
          position    : 'absolute',
          top         : 16,
          right       : 16,
          display     : 'flex',
          alignItems  : 'center',
          gap         : 2,
          fontSize    : 11,
          fontWeight  : 600,
          color       : ts.color,
          background  : ts.bg,
          borderRadius: 20,
          padding     : '3px 8px',
          lineHeight  : 1,
        }}>
          {pct > 0 && <TrendingUpIcon style={{ fontSize: 12 }} />}
          {pct}%
        </div>

        {/* big number */}
        <div style={{
          fontSize     : 42,
          fontWeight   : 800,
          color        : numCol,
          lineHeight   : 1,
          fontFamily   : "'DM Sans', sans-serif",
          letterSpacing: '-1.5px',
        }}>
          {typeof leadCount === 'number' ? leadCount.toLocaleString() : leadCount}
        </div>

        {/* stage label */}
        <div style={{
          fontSize     : 11,
          fontWeight   : 600,
          letterSpacing: '0.09em',
          color        : textSec,
          marginTop    : 16,
          textTransform: 'uppercase',
        }}>
          {stageName}
        </div>
      </div>
    );
  };

  /* ── render ── */
  return (
    <div style={{ width: '100%' }}>

      {/* section header */}
      <div style={{
        display       : 'flex',
        justifyContent: 'space-between',
        alignItems    : 'flex-start',
        marginBottom  : 22,
      }}>
        <div>
          <h2 style={{
            margin    : 0,
            fontSize  : 20,
            fontWeight: 700,
            color     : textPri,
            fontFamily: "'DM Sans', sans-serif",
          }}>
            Quick Numbers
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: textSec }}>
            Real-time engagement metrics for your portfolio
          </p>
        </div>

        <button
          onClick={() => navigate('/AllLeadsForAdminCRMDataQuickNumbers')}
          style={{
            background    : 'none',
            border        : 'none',
            cursor        : 'pointer',
            color         : accent,
            fontSize      : 13,
            fontWeight    : 700,
            fontFamily    : "'DM Sans', sans-serif",
            textDecoration: 'none',
            padding       : 0,
          }}
          onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
          onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
        >
          View Data Center
        </button>
      </div>

      {/* card grid */}
      <div style={{
        display            : 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap                : 16,
      }}>
        {sortedCards.map((card) => (
          <Card
            key      ={card.key}
            stageName={card.stageName}
            leadCount={card.leadCount}
            onClick  ={card.onClick}
            pct      ={card.pct}
          />
        ))}
      </div>
    </div>
  );
};
